<template>
  <div class="main">
    <div class="form-bg">
      <el-form :model="ruleForm" status-icon :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
        <el-form-item :label="$t('userInfo.username')" prop="username">
          <el-input type="text" v-model="ruleForm.username" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item :label="$t('userInfo.Nickname')" prop="nickname">
          <el-input type="text" v-model="ruleForm.nickname" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item :label="$t('userInfo.password')" prop="pass">
          <el-input type="password" v-model="ruleForm.pass" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item :label="$t('userInfo.confirmPWD')"  prop="checkPass">
          <el-input type="password" v-model="ruleForm.checkPass" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item :label="$t('userInfo.code')"  prop="checkCode">
          <el-input type="text" v-model="ruleForm.checkCode" autocomplete="off" class="code-input"></el-input>
          <img :src="codeImg" @click="refreshCode" class="img-code"/>
        </el-form-item>
        <el-form-item>
          <el-button type="success" @click="submitForm('ruleForm')">{{this.$t('common.Register')}}</el-button>
          <el-button @click="login()">{{this.$t('common.login')}}</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
  import axios from '@/axios'

  export default {
    name: 'register',
    data() {
      var validateusername = (rule, value, callback) => {
        if (value === '') {
          callback(new Error(this.$t('message.enterName')));
        } else {
          callback();
        }
      };
      var validatePass = (rule, value, callback) => {
        if (value === '') {
          callback(new Error(this.$t('message.enterPWD')));
        } else {
          if (this.ruleForm.checkPass !== '') {
            this.$refs.ruleForm.validateField('checkPass');
          }
          callback();
        }
      };
      var validatePass2 = (rule, value, callback) => {
        if (value === '') {
          callback(new Error(this.$t('message.pwdAgain')));
        } else if (value !== this.ruleForm.pass) {
          callback(new Error(this.$t('message.pwdMatch')));
        } else {
          callback();
        }
      };
      var validatecheckCode = (rule, value, callback) => {
        if (value === '') {
          callback(new Error(this.$t('message.enterCode')));
        } else {
          callback();
        }
      };
      return {
        ruleForm: {
          username: '',
          nickname: '',
          pass: '',
          checkPass: '',
          checkCode: ''
        },
        codeImg: '',
        uuid: '',
        rules: {
          username: [
            {validator: validateusername, trigger: 'blur'}
          ],
          pass: [
            {validator: validatePass, trigger: 'blur'}
          ],
          checkPass: [
            {validator: validatePass2, trigger: 'blur'}
          ],
          checkCode: [
            {validator: validatecheckCode, trigger: 'blur'}
          ]
        }
      };
    },
    created: function () {
      this.refreshCode();
    },
    methods: {
      // 点击刷新验证码
      refreshCode() {
        this.uuid = this.getuuid();
        this.codeImg = 'http://hdd.mrtlab.com:8080/api/captcha.jpg?uuid=' + this.uuid
      },
      getuuid() {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
          var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
          return v.toString(16);
        });
      },
      submitForm(formName) {
        let _this = this;
        let username = this.ruleForm.username;
        let nickname = this.ruleForm.nickname;
        let password = this.ruleForm.pass;
        let code = this.ruleForm.checkCode;
        let uuid = this.uuid;
        this.$refs[formName].validate((valid) => {
          if (valid) {
            if (nickname === '' || nickname == null) {
              nickname = username;
            }
            axios.post(this.$store.state.apiBasePath + "/register", {
              username: username,
              nickname: nickname,
              password: password,
              code: code,
              uuid: uuid,
            }).then(function (res) {
              console.log(res);
              var data = res.data;
              if (data.code == 200) {
                _this.$router.push('/login')
              } else {
                _this.$message({
                  type: 'error',
                  title:this.$t('message.Error'),
                  message:res.data.msg,
                  showClose: true,
                  offset:300,
                  duration:3000,
                });
              }
            })
          } else {
            return false;
          }
        });
      },
      login() {
        this.$router.push('/login')
      }
    }


  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .mian {
    min-height: calc(100% - 486px);
  }
  .form-bg {
    width: 500px;
    margin: 80px auto;
    background: #fff;
    border: #ddd 1px solid;
    padding: 30px 30px;
    border-radius: 5px;
    box-shadow: #ddd 0 0 10px;
  }

  .code-input {
    float: left;
    width: 225px;
  }

  .img-code {
    display: inline-block;
    height: 40px;
    border-radius: 3px;
    float: right;
    width: 160px;
  }
</style>



// WEBPACK FOOTER //
// src/components/register.vue